import {
  Chip,
  DataArray,
  UpdateIconButton,
  formatBoolean,
  pn,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@compass/core";

import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  StudentServiceTypeListDto,
  StudentServiceTypeListResource,
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { studentServiceTypePageRoute } from "../StudentServiceTypePage/StudentServiceTypePage";

export const StudentServiceTypeTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  studentServiceTypes: StudentServiceTypeListDto[];
  setStudentServiceTypes: (studentServiceTypes: StudentServiceTypeListDto[]) => void;
  resource: StudentServiceTypeListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentServiceTypeListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentServiceTypeListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find(
                  (x) => x.propertyName === pn<StudentServiceTypeListDto>("aprStudentService")
                )}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentServiceTypeListDto>("schools"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell align="center">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentServiceTypeListDto>("inactive"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.studentServiceTypes.map((studentServiceTypeItem) => (
            <TableRow
              key={studentServiceTypeItem.id}
              onClick={() =>
                navigate(
                  studentServiceTypePageRoute.getPath({
                    id: studentServiceTypeItem.id,
                    crudMode: "view",
                  })
                )
              }
            >
              <TableCell type="id">{studentServiceTypeItem.id}</TableCell>
              <TableCell>
                <Stack direction="row" spacing="sm" alignItems="center" justifyContent={"space-between"}>
                  <Typography variant="inherit">{studentServiceTypeItem.name}</Typography>
                  <Stack direction="row">
                    {studentServiceTypeItem.isForParent ? (
                      <Tooltip title="Parent service type">
                        <Chip label="P" size="xsmall" color="success" rectangular />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Student service type">
                        <Chip label="S" size="xsmall" color="primary" rectangular />
                      </Tooltip>
                    )}

                    <Tooltip title={`This Service Type has ${studentServiceTypeItem.subTypesCount} Sub-types`}>
                      <Chip label={studentServiceTypeItem.subTypesCount} size="xsmall" rectangular />
                    </Tooltip>
                  </Stack>
                </Stack>
              </TableCell>
              <TableCell>{studentServiceTypeItem.aprStudentService}</TableCell>
              <TableCell>
                <DataArray value={studentServiceTypeItem.schools} max={1} />
              </TableCell>
              <TableCell align="center">{formatBoolean(studentServiceTypeItem.inactive)}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() =>
                      navigate(
                        studentServiceTypePageRoute.getPath({
                          id: studentServiceTypeItem.id,
                          crudMode: "edit",
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
